import { Box, Typography } from "@mui/material";
import React from "react";
import Skeleton from "react-loading-skeleton";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import './CustomPhoneNumber.css'
const CustomPhoneNumber = ({
  label,
  placeholder,
  name,
  value,
  errors,
  onChange,
  isLoading,
  country
}) => {
  return (
    <Box sx={{ width: "100%" }}>
      {isLoading ? (
        <Skeleton height={60} />
      ) : (
        <PhoneInput
          className=""
          name={name}
          country={country}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          inputClass="inputClassCountry"
        />
      )}
      {errors ? (
        <Typography
          sx={{
            color: "red",
            fontWeight: "400",
            fontSize: { xs: "14px", sm: "14px" },
            padding: '0 8px ',
            marginTop: '4px'
          }}
        >
          {errors}
        </Typography>
      ) : null}
    </Box>
  );
};

export default CustomPhoneNumber;
